/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WatchlistListDto
 */
export interface WatchlistListDto {
    /**
     * 
     * @type {string}
     * @memberof WatchlistListDto
     */
    iconName: WatchlistListDtoIconNameEnum;
    /**
     * 
     * @type {string}
     * @memberof WatchlistListDto
     */
    colorName: WatchlistListDtoColorNameEnum;
    /**
     * 
     * @type {string}
     * @memberof WatchlistListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WatchlistListDto
     */
    name: string;
}

/**
* @export
* @enum {string}
*/
export enum WatchlistListDtoIconNameEnum {
    Wallet = 'Wallet',
    WalletFilled = 'WalletFilled',
    Profits = 'Profits',
    ProfitsFilled = 'ProfitsFilled',
    Trades = 'Trades',
    TradesFilled = 'TradesFilled',
    Dividends = 'Dividends',
    DividendsFilled = 'DividendsFilled',
    AccountingDocument = 'AccountingDocument',
    Bell = 'Bell',
    BellFilled = 'BellFilled',
    ChartBar = 'ChartBar',
    HeartFilled = 'HeartFilled',
    Heart = 'Heart',
    CompoundInterest = 'CompoundInterest',
    ChartBarFilled = 'ChartBarFilled'
}/**
* @export
* @enum {string}
*/
export enum WatchlistListDtoColorNameEnum {
    Blue = 'blue',
    BlueLight = 'blueLight',
    BlueDark = 'blueDark',
    Purple = 'purple',
    PurpleLight = 'purpleLight',
    PurpleDark = 'purpleDark',
    Green = 'green',
    GreenLight = 'greenLight',
    GreenDark = 'greenDark',
    Primary = 'primary',
    PrimaryLight = 'primaryLight',
    PrimaryDark = 'primaryDark',
    Secondary = 'secondary',
    SecondaryLight = 'secondaryLight',
    SecondaryDark = 'secondaryDark',
    Gray = 'gray',
    GrayLight = 'grayLight',
    GrayDark = 'grayDark',
    Orange = 'orange',
    OrangeLight = 'orangeLight',
    OrangeDark = 'orangeDark',
    Red = 'red',
    RedLight = 'redLight',
    RedDark = 'redDark',
    Pink = 'pink',
    PinkLight = 'pinkLight',
    PinkDark = 'pinkDark',
    Brown = 'brown',
    BrownLight = 'brownLight',
    BrownDark = 'brownDark',
    Yellow = 'yellow',
    YellowLight = 'yellowLight',
    YellowDark = 'yellowDark'
}

export function WatchlistListDtoFromJSON(json: any): WatchlistListDto {
    return WatchlistListDtoFromJSONTyped(json, false);
}

export function WatchlistListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchlistListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function WatchlistListDtoToJSON(value?: WatchlistListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iconName': value.iconName,
        'colorName': value.colorName,
        'id': value.id,
        'name': value.name,
    };
}

